import { StateParams } from "@uirouter/angularjs";
import { IOnInit, ICompileService } from "angular";
import { RecordDataSource } from "../../../records/grids";
import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../records/server/query";
import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../app/records/server/serverUtility";

import "angular-formly";
const gridId = Symbol("main.contract.machine.view.grid");
export class MachinesViewController implements IOnInit {
  static $inject = [
    serverUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    RecordGridViewServiceName,
  ];
  gridDataSource!: RecordDataSource;
  gridSettings!: IGridSettings;
  columns!: ColDef[];
  defaultQuery: IQuery = {};
  contract: any;

  constructor(
    public readonly serverUtility: ServerUtility,
    private readonly gridSettingsService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    private readonly recordGridViewService: RecordGridViewService
  ) {
    const gridConfiguration: GridConfiguration | undefined =
      this.recordGridViewService.getGridConfiguration("machine");
    if (!gridConfiguration) {
      throw new Error(
        "Must have machineConfiguration registered with recordGridViewService"
      );
    }

    this.columns = [
      columnDefinitionService.getLinkColDef({
        colId: "info",
        headerName: " ",
        iconClass: "fa fa-info-circle text-primary",
        stateExpression:
          "main.machines.machine.configurations({ machineId: data.MachineId})",
        requiresPermission: "machineView",
      }),
      ...(gridConfiguration?.columns ?? []),
    ];
  }

  $onInit(): void {
    this.gridDataSource = new RecordDataSource(
      this.serverUtility,
      "/api/contract/contractMachines/" + this.contract.Id
    );
    this.gridSettings = this.gridSettingsService.getGridSettings(gridId);
  }
}
